import styles from "./Loading.module.scss";

const Loading = () => {
  return <div className={styles.loadingOverlay}></div>;
};
export default Loading;
